<template>
  <page>
    <template slot="content">
      <help-content :title="'過去の計測データの確認方法は？'">
        <template slot="content">
          <div class="text">
            歩数の履歴データはホームの「歩数」をタップして、折れ線グラフを左右に動かすことで確認することができます。
          </div>
          <img class="picture" src="../assets/images/q_and_a/H13_1.png">
          <div class="text">
            ランニングの履歴データはホームの「ウォーク/ラン」>「運動履歴」から確認することができます。
          </div>
          <img class="picture" src="../assets/images/q_and_a/H13_2.png">
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help13.vue